import { FC } from 'react'
import { Formik } from 'formik';
import { Box } from '@mui/material';
import { Form } from 'react-router-dom';

import Plans from '../../../../../components/Plans';
import { useAppSelector } from '../../../../../hooks/redux';

type FormikValues = {
  plan: number;
}

const Subscription: FC = () => {
  const {plan} = useAppSelector(state => state.plan);

  const initialValues = {
    plan: plan ?? 1,
  };

  const handleSubmit = (values: FormikValues) => {
    localStorage.setItem("createAccount", JSON.stringify(values));
  };

  const formikValidate = (values: FormikValues) => {
    const errors: Partial<FormikValues> = {};

    return errors;
  }

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validate={formikValidate}
        onSubmit={handleSubmit}
      >
        {({ values, errors, handleChange, isSubmitting }) => (
          <Form>
             <Plans values={values} isUpdateOnClick={true} hideHeader={true} onChangePlan={handleChange} />
          </Form>)}
      </Formik>
    </Box>
  )
}

export default Subscription;
